<div class="flex w-full flex-col bg-white py-2 rounded-xl">
  <div
    class="flex w-full justify-between bg-white py-4 pr-4 border-transparent border-[2px] border-b-gray-300"
  >
    <div class="flex gap-4">
      <div class="h-10 w-1 bg-primary"></div>
      <span>Contact Details</span>
    </div>
    <div
      (click)="contactDetails = !contactDetails"
      class="p-1 rounded-full h-6 w-6 bg-gray-300"
    >
      <img src="../../../assets/image/Arrows.svg" />
    </div>
  </div>
  <div *ngIf="contactDetails" class="w-full">
    <form
      [formGroup]="customerContactForm"
      class="p-5 grid md:grid-cols-2 grid-col-1 gap-4"
    >
      <div class="w-full gap-2 flex flex-col">
        <span>Mobile</span>

        <input
          formControlName="Mobile"
          name="Mobile"
          class="w-full border p-2 rounded-md outline-none"
          placeholder="Enter Your mobile number"
          (keypress)="keyPressNumbers($event)"
        />
        <div
          *ngIf="customerContactForm.controls['Mobile'].errors?.['pattern']"
          class="text-red-500"
        >
          Invalid Phone Number
        </div>
      </div>
      <div class="w-full gap-2 flex flex-col">
        <span>Address</span>

        <input
          formControlName="Address"
          name="Address"
          class="w-full border p-2 rounded-md outline-none"
          placeholder="Enter Your address"
        />
      </div>
      <div class="w-full gap-2 flex flex-col">
        <span>Telephone No</span>

        <input
          formControlName="TelephoneNo"
          name="TelephoneNo"
          class="w-full border p-2 rounded-md outline-none"
          placeholder="Enter your telephone no"
        />
      </div>
      <div class="w-full gap-2 flex flex-col">
        <span>State</span>

        <input
          formControlName="state"
          name="state"
          class="w-full border p-2 rounded-md outline-none"
          placeholder="Enter Your state"
        />
      </div>
      <div class="w-full gap-2 flex flex-col">
        <span>Postal Code</span>

        <input
          formControlName="postalCode"
          (keypress)="keyPressNumbers($event)"
          maxlength="6"
          name="postalCode"
          class="w-full border p-2 rounded-md outline-none"
          placeholder="Enter Your pstal code"
        />
        <div
          *ngIf="customerContactForm.controls['postalCode'].errors?.['pattern']"
          class="text-red-500"
        >
          Invalid Postal Code
        </div>
      </div>

      <div class="w-full gap-2 flex flex-col">
        <span>City</span>

        <select
          class="w-full p-2 outline-none border rounded-md"
          formControlName="city"
          name="city"
        >
          <option>Enter Your City</option>
        </select>
      </div>
      <div class="w-full gap-2 flex flex-col">
        <span>Country</span>

        <select
          class="w-full p-2 outline-none border rounded-md"
          formControlName="country"
          name="country"
        >
          <option>Enter Your Country</option>
        </select>
      </div>
    </form>
  </div>
</div>
